// extracted by mini-css-extract-plugin
module.exports = {"sider":"App_sider__3ZkIN","content":"App_content__3La4L","siderMobile":"App_siderMobile__38e4r"};